import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { AppState } from "../../../../../../stateManager/store";
import { setFixedElements, setFixedElementsV3 } from "../../../../../../stateManager/store/formCreation_v2/actions";
import { getValue, getComponents } from "../../helpers";
import { Checkbox } from "./helpers/constants";

import { onChange } from "./helpers/on-change"
import { Tooltip } from "../../helpers/Toottip";

const DEFAULT_POSITION_ABSOLUTE = "properties.styles.$deviceType.absolute";
const DEFAULT_POSITION_FIXED = "properties.styles.$deviceType.fixed";
const DEFAULT_ABSOLUTE_TOP = "properties.styles.$deviceType.top";
const DEFAULT_ABSOLUTE_RIGHT = "properties.styles.$deviceType.right";
const DEFAULT_ABSOLUTE_BOTTOM = "properties.styles.$deviceType.bottom";
const DEFAULT_ABSOLUTE_LEFT = "properties.styles.$deviceType.left";


type Props = {
  label?: string;
  isCheckedIn: boolean;
  defaultValue?: boolean;
}

export const Absolute = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState(Boolean);
  const [value, setValue] = useState(defaultValue);
  const component = components[selectedElementId];

 const setdefaultValueAbsolute = getValue(component,  DEFAULT_POSITION_FIXED.split("."), deviceType)
 const absoluteDefaultCheck = setdefaultValueAbsolute === true

  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, DEFAULT_POSITION_ABSOLUTE.split("."), deviceType);
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_POSITION_ABSOLUTE.split("."), deviceType)]);

  return (
    <Checkbox
      disabled={!isCheckedIn || absoluteDefaultCheck}
      key={label}
      id="absolute"
      value={value ? value : false}
      label="Absolute"
      type={component?.type}
      onChange={(_, value: boolean) => {
        setValue(value);
        onChange({
          path: DEFAULT_POSITION_ABSOLUTE,
          value,
          oldValue,
          setOldValue,
          selectedElementId
        })
      }}
    />
  )
};
export const Fixed = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3 } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState(Boolean);
  const [value, setValue] = useState(defaultValue);
  const component = components[selectedElementId];
  const fixedArray = useSelector((state: any) => state.formJson.fixedArray) || []
  const dispatch = useDispatch()
  const fixedArrayV3 = useSelector(
    (state: AppState) => state?.formJson?.fixedArrayV3?.[deviceType] || []
  );

  const setdefaultValueFixed = getValue(component, DEFAULT_POSITION_ABSOLUTE.split("."), deviceType)
  const fixedDefaultCheck = setdefaultValueFixed === true

  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, DEFAULT_POSITION_FIXED.split("."), deviceType);
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_POSITION_FIXED.split("."), deviceType)]);

  const isCheckboxDisabled = () => {
    if (isCoreV3) {
      return isCheckedIn ? fixedArrayV3.length > 0 && !value : true;
    } else {
      return isCheckedIn ? fixedArray.length > 0 && !value : true;
    }
  };

  return (
    <Tooltip content="Only one 'Fixed' widget allowed per device type" top={15}>
    <Checkbox
      disabled={isCheckboxDisabled() || fixedDefaultCheck}
      key={label}
      id="fixed"
      value={value ? value : false}
      label="Fixed"
      type={component?.type}
      onChange={(_, value: boolean) => {
        setValue(value);
        if(isCoreV3){
          let updatedFixedArray = [...fixedArrayV3];
          if (value === true) {
            updatedFixedArray.push(selectedElementId);
          } else {
            updatedFixedArray = updatedFixedArray.filter(
              (elem) => elem !== selectedElementId
            );
          }
          dispatch(setFixedElementsV3(updatedFixedArray));
        }else{
          let updatedFixedArray = [...fixedArray]
          if (value === true) {
            updatedFixedArray.push(selectedElementId)
          } else {
            updatedFixedArray = updatedFixedArray.filter(elem => elem !== selectedElementId)
          }
          dispatch(setFixedElements(updatedFixedArray))
        }
        onChange({
          path: DEFAULT_POSITION_FIXED,
          value,
          oldValue,
          setOldValue,
          selectedElementId
        })
      }}
    />
    </Tooltip>
  )
};


export const AbsoluteTop = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson)
  const { defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500 || "");
  const component = components[selectedElementId];

  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, DEFAULT_ABSOLUTE_TOP.split("."), deviceType);
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_ABSOLUTE_TOP.split("."), deviceType)]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "28px",
        width: "34px",
        border: "2px solid #7D84924D",
        borderRadius: "2px",
        borderTopRightRadius: "3.5px",
        borderTopLeftRadius: "3.5px",
        borderTop: "none",
        marginLeft: "7px"
      }}
    >
    <input
      style={{
        position: "absolute",
        height: "28px",
        width: "34px",
        borderWidth: "2.3px",
        borderTopColor:  (value && value != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ",
        borderStyle: "solid",
        borderLeft: "none",
        borderRadius: "4px",
        borderRight: "none",
        borderBottom: "none",
        background: "none",
        outline: "none",
      }}
      className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
      disabled={!props.isCheckedIn}
      type="number"
      min="0"
      id="absolutetop"
      data-test-id={`${component?.type}-absolute_top`}
      // className=" bg-white border text-gray-900 font-normal rounded-md w-11 p-2.5 text-center dark:text-white focus:outline-none ml-11"
      placeholder="0"
      value={value}
      onChange={e => {
        const changeValue = e.target.value;
        const value = changeValue ? Number(changeValue) >= 0 ? changeValue : "0": changeValue;
        setValue(value, () => onChange({
          path: DEFAULT_ABSOLUTE_TOP,
          value,
          oldValue,
          setOldValue,
          selectedElementId
        }))
      }}
    />
    </div>
  )
}

export const AbsoluteRight = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson)
  const { defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500 || "");
  const component = components[selectedElementId];

  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, DEFAULT_ABSOLUTE_RIGHT.split("."), deviceType);
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_ABSOLUTE_RIGHT.split("."), deviceType)]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "28px",
        width: "34px",
        border: "2px solid #7D84924D",
        borderRadius: "2px",
        borderTopRightRadius: "3.5px",
        borderBottomRightRadius: "3.5px",
        borderRight: "none",
        marginLeft: "7px"
      }}
    >
    <input
      style={{
        position: "absolute",
        height: "28px",
        width: "34px",
        borderWidth: "2.3px",
        borderStyle: "solid",
        borderRadius: "4px",
        borderRightColor: (value && value != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ",
        borderBottom: "none",
        borderLeftWidth: "2.3px",
        borderLeftColor: "transparent",
        background: "none",
        borderTop: "none",
        outline: "none",
      }}
      className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
      disabled={!props.isCheckedIn}
      type="number"
      min="0"
      id="absoluteright"
      data-test-id={`${component?.type}-absolute_right`}
      placeholder="0"
      value={value}
      onChange={e => {
        const changeValue = e.target.value;
        const value = changeValue ? Number(changeValue) > 0 ? changeValue: "0": changeValue;
        setValue(value, () => onChange({
          path: DEFAULT_ABSOLUTE_RIGHT,
          value,
          oldValue,
          setOldValue,
          selectedElementId
        }))
      }}
    />
    </div>
  )
}

export const AbsoluteBottom = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson)
  const { defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500 || "");
  const component = components[selectedElementId];

  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, DEFAULT_ABSOLUTE_BOTTOM.split("."), deviceType);
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_ABSOLUTE_BOTTOM.split("."), deviceType)]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "28px",
        width: "34px",
        border: "2px solid #7D84924D",
        borderRadius: "2px",
        borderBottomRightRadius: "3.5px",
        borderBottomLeftRadius: "3.5px",
        borderBottom: "none",
        marginLeft: "7px"
      }}
    >
    <input
      style={{
        position: "absolute", left: "-1.5px",
        height: "28px",
        width: "34px",
        borderWidth: "2.3px",
        borderStyle: "solid",
        borderRadius: "4px",
        borderBottomColor: (value && value != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ",
        borderRight: "none",
        borderTopWidth: "2.3px",
        borderTopColor: "transparent",
        borderLeft: "none",
        background: "none",
        outline: "none",
      }}
      className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
      disabled={!props.isCheckedIn}
      type="number"
      min="0"
      id="absolutebottom"
      data-test-id={`${component?.type}-absolute_bottom`}
      placeholder="0"
      value={value}
      onChange={e => {
        const changeValue = e.target.value;
        const value = changeValue ? Number(changeValue) > 0 ? changeValue: "0": changeValue;
        setValue(value, () => onChange({
          path: DEFAULT_ABSOLUTE_BOTTOM,
          value,
          oldValue,
          setOldValue,
          selectedElementId
        }))
      }}
    />
    </div>
  )
}

export const AbsoluteLeft = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson)
  const { defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500 || "");
  const component = components[selectedElementId];

  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, DEFAULT_ABSOLUTE_LEFT.split("."), deviceType);
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_ABSOLUTE_LEFT.split("."), deviceType)]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "28px",
        width: "34px",
        border: "2px solid #7D84924D",
        borderRadius: "2px",
        borderTopLeftRadius: "3.5px",
        borderBottomLeftRadius: "3.5px",
        borderLeft: "none",
        marginLeft: "7px"
      }}
    >
    <input
      style={{
        position: "absolute",
        height: "28px",
        width: "34px",
        borderWidth: "2.3px",
        borderStyle: "solid",
        borderRadius: "4px",
        borderLeftColor: (value && value != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ",
        borderBottom: "none",
        borderRightWidth: "2.3px",
        borderRightColor: "transparent",
        background: "none",
        borderTop: "none",
        outline: "none",
      }}
      className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
      disabled={!props.isCheckedIn}
      type="number"
      min="0"
      id="absoluteleft"
      data-test-id={`${component?.type}-absolute_left`}
      placeholder="0"
      value={value}
      onChange={e => {
        const changeValue = e.target.value;
        const value = changeValue ? Number(changeValue) > 0 ? changeValue : "0": changeValue;
        setValue(value, () => onChange({
          path: DEFAULT_ABSOLUTE_LEFT,
          value,
          oldValue,
          setOldValue,
          selectedElementId
        }))
      }}
    />
    </div>
  )
}